import React, { FC, useContext, useState } from 'react'
import { FormikHelpers } from 'formik'
import { useTranslations } from 'next-intl'
import { RegistrationForm } from '../RegistrationForm/RegistrationForm'
import { FormFirstNameField } from '../../../../formComponents/FormFirstNameField/FormFirstNameField'
import { FRONTEND_ERROR_CODE } from '../../../../formComponents/constants'
import IFormRegistrationValues from '../../../IFormRegistrationValues'
import { IOrganizationsItem } from '../../../../../interfaces/IOrganizationsItem'
import { FormFieldTypes } from '../../../../../emun/RegistrationFormFieldTypes'
import { Languages } from '../../../../../interfaces/common'
import { SocialNetworks } from '../../../../../emun/social'
import { LocaleContext } from '../../../../LocaleContext/LocaleContext'
import { FormLastNameField } from '../../../../formComponents/FormLastNameField/FormLastNameField'
import { FormPhoneField } from '../../../../formComponents/FormPhoneField/FormPhoneField'
import { FormPositionField } from '../../../../formComponents/FormPositionField/FormPositionField'
import { IUserChangeParams } from '../../../../../interfaces/IUserChangeParams'

interface IForm13Values extends IFormRegistrationValues {
  [FormFieldTypes.Position]: IOrganizationsItem
  [FormFieldTypes.SmsCode]: string
}

const initialForm13Data = {
  [FormFieldTypes.Email]: '',
  [FormFieldTypes.FirstName]: '',
  [FormFieldTypes.LastName]: '',
  [FormFieldTypes.Password]: '',
  [FormFieldTypes.Phone]: '',
  [FormFieldTypes.Position]: { name: '', id: '' },
  [FormFieldTypes.SmsCode]: '',
}

type RegistrationForm13Props = {
  onSocialAuth(socialNetwork: SocialNetworks, callbackUrl?: string): void
}

export const RegistrationForm13: FC<RegistrationForm13Props> = ({ onSocialAuth }) => {
  const t = useTranslations()
  const { locale } = useContext(LocaleContext)

  const [isPhoneConfirmed, setIsPhoneConfirmed] = useState<boolean>(false)

  const onSubmit = (values: IForm13Values): IUserChangeParams => ({
    ...values,
    phone: values.phone.replace(/\s/g, '').replace('+', ''),
    firstName: values.firstName.trim(),
    lastName: values.lastName.trim(),
    position: values.position.name.trim(),
    smsCode: values.smsCode,
  })

  const onSubmitError = (formProps: FormikHelpers<IFormRegistrationValues>, error: any) => {
    if (error.status === FRONTEND_ERROR_CODE) {
      formProps.setFieldError(FormFieldTypes.SmsCode, t(`app.formComponents.form.serverErrors.${error.error.message}`))
    }
  }

  return (
    <RegistrationForm
      onSocialAuth={onSocialAuth}
      initialFormData={initialForm13Data}
      onSubmit={onSubmit}
      onSubmitError={onSubmitError}
      isPhoneConfirmed={isPhoneConfirmed}
    >
      <FormFirstNameField />
      <FormLastNameField />
      <FormPhoneField setIsPhoneConfirmed={setIsPhoneConfirmed} withCode onlySmsCode={locale !== Languages.RU} />
      <FormPositionField />
    </RegistrationForm>
  )
}

RegistrationForm13.displayName = 'RegistrationForm13'
